import {createSelector} from "reselect";


export const getObjectsSelector = (state) => state.objects?.objects

export const getObjectsPercentSelector = createSelector(getObjectsSelector, (objects) => {
    if(!objects) return
    let filtredObjects = {}

    Object.keys(objects).map(object => {
        if (objects[object].paymentType === "percent") {
            filtredObjects = {...filtredObjects, [object]: objects[object]}
        }
    })
    return filtredObjects
})



export const getCountPagesSelector = (state) => {
    return state.objects?.navParams?.pages
}
export const getSearchStringSelector = (state) => {
    return state.objects?.navParams?.search
}

export const getCurrentPageSelector = (state) => {
    return state.objects?.currentPage
}



